module.exports = __webpack_public_path__ + "img/cloud-hail-mixed.6be2a1e0.svg";